module.exports = __webpack_public_path__ + "static/media/team6.f3e333e8.png";